export const GST_REGEX = '^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$';

// Currently used this regex for email validation
export const EMAIL_REGEX = /^[\w-+.]+@([\w-]+\.)+[\w-]{2,4}$/;

export const TEXT_REGEX = /^[A-Za-z\s]+$/;

// Need to discuss with the team for the regex
// export const EMAIL_REGEX = /^[\w-+.]+@([\w-]+\.)+[\w-]{2,}$/;

export const INDIA_PHONE_REGEX = /^(\+91-|\+91|0)?\d{10}$/;

export const PHONE_REGEX = /^\d{10}$/;

export const PAN_NUMBER = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
